import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AdminRole } from '../../models/auth.model';

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const expectedRoles = (route.data?.['roles'] as AdminRole[] | undefined) ?? [];

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth/login'], {
      queryParams: {
        returnUrl: router.url,
      },
    });
  }

  if (authService.hasRole(expectedRoles)) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
